export const MAIN_LINKS = [
    {
      href: "/",
      name: "Home",
    },
    {
      href: "/services",
      name: "Services",
    },
    {
      href: "/aboutus",
      name: "About Us",
    },
    {
      href: "/contactus",
      name: "Contact",
    },
  ];
  
  export const FOOTER_SERVICE_LINKS = [
    {
      href: "/services/baghouse-conversions",
      name: "Baghouse Conversions",
    },
    {
      href: "/services/engineering-evaluations",
      name: "Engineering Evaluations",
    },
    {
      href: "/services/master-service-contracts",
      name: "Master Service Contracts",
    },
    {
      href: "/services/preventive-maintenance-plans",
      name: "Preventive Maintenance Plans",
    },
    {
      href: "/services/troubleshooting",
      name: "Troubleshooting",
    },
    {
      href: "/services/inspections-reports",
      name: "Inspections & Reports",
    },
    {
      href: "/services/maintenance-repairs",
      name: "Maintenance Repairs",
    },
    {
      href: "/services/filter-bag-changeovers",
      name: "Filter Bag Changeovers",
    },
  ];
  
  export const COMPANY_SERVICE_LINKS = [
    {
      href: "/",
      name: "Home",
    },
    {
      href: "/services",
      name: "Services",
    },
    {
      href: "/aboutus",
      name: "About Us",
    },
    {
      href: "/contactus",
      name: "Contact Us",
    },
  ];
  